import { useState, useEffect, useCallback } from 'react';
import { formatPhoneForDisplay } from '../../../utils/phoneUtils';

const createFormValues = (userData) => {
  if (!userData) return {};
  return {
    username: userData.username || '',
    email: userData.email || '',
    phone: formatPhoneForDisplay(userData.phone),
    categoryName:
      userData.end_users_category?.name || userData.categoryName || '',
    category: userData.category?.id || userData.end_users_category?.id || '',
    role: userData.Role?.id || userData.role || '',
  };
};

const useProfileForm = (userData) => {
  const [form, setForm] = useState(() => createFormValues(userData));
  const [passwordVerified, setPasswordVerified] = useState(false);
  const [editingPersonal, setEditingPersonal] = useState(false);
  const [editingContact, setEditingContact] = useState(false);
  const [activeTab, setActiveTab] = useState(0);

  useEffect(() => {
    if (userData) {
      setForm(createFormValues(userData));
      setEditingPersonal(false);
      setEditingContact(false);
      setPasswordVerified(false);
    }
  }, [userData]);

  const discardChanges = useCallback(() => {
    if (userData) {
      setForm(createFormValues(userData));
    }
  }, [userData]);

  const discardRoleFields = useCallback(() => {
    if (!userData) return;
    setForm((prev) => ({
      ...prev,
      categoryName:
        userData.end_users_category?.name || userData.categoryName || '',
      category: userData.category?.id || userData.end_users_category?.id || '',
      role: userData.Role?.id || userData.role || '',
    }));
  }, [userData]);

  const handleTabChange = useCallback((_, value) => {
    setActiveTab(value);
  }, []);

  return {
    form,
    setForm,
    passwordVerified,
    setPasswordVerified,
    activeTab,
    editingPersonal,
    setEditingPersonal,
    editingContact,
    setEditingContact,
    discardChanges,
    discardRoleFields,
    handleTabChange,
  };
};

export default useProfileForm;
